<template>
  <div class="breadcrumb-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item
        v-for="(item, index) in breadcrumbList"
        :key="index"
        :to="{ path: item.path }"
      >
        {{ item.name }}
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumb',
  computed: {
    // 解析路由生成面包屑列表
    breadcrumbList() {
      const matched = this.$route.matched.filter(item => item.meta && item.meta.breadcrumb)
      return matched.map(item => {
        let breadcrumbName = item.meta.breadcrumb
        // 处理动态面包屑
        if (item.meta.breadcrumbResolve) {
          breadcrumbName = item.meta.breadcrumbResolve(item)
        }
        return {
          path: item.path,
          name: breadcrumbName
        }
      })
    }
  }
}
</script>

<style scoped>
.breadcrumb-container {
  padding: 10px 20px;
  background: #fff;
  margin-bottom: 20px;
  border-bottom: 1px solid #eee;
}
</style>